const initialState = {
  isLoading: false,
  roomNames: {},
  roomAttendanceSchedules: {},
  roomRatios: {},
  rooms: [{
    id: 0,
    name: 'Floats'
  }],
  selectedRoomIds: []
};

export function rooms (state = initialState, action) {
  switch (action.type) {
    case 'SELECT_ROOMS':
      return {
        ...state,
        selectedRoomIds: action.value ? [...state.selectedRoomIds, action.id] : state.selectedRoomIds.filter(r => r !== action.id)
      };
    case 'FETCH_ROOMS':
      return {
        ...state,
        isLoading: false
      };
    case 'FETCH_ROOMS_LOADING':
      return {
        ...state,
        isLoading: true
      };
    case 'FETCH_ROOMS_SUCCESS':
      return {
        ...state,
        isLoading: false,
        roomNames: Object.assign({}, ...action.rooms.map(room => ({
          [room.id]: room.name
        }))),
        roomAttendanceSchedules: Object.assign({}, ...action.rooms.map(room => ({ [room.id]: room.projectedAttendance }))),
        roomRatios: Object.assign({}, ...action.rooms.map(room => ({ [room.id]: room.ratio }))),
        rooms: [ {
          id: 0,
          name: 'Floats'
        }, ...action.rooms],
        selectedRoomIds: [ {
          id: 0,
          name: 'Floats'
        }, ...action.rooms].map((r) => r.id)
      };
    default:
      return state;
  }
}
